<template>
  <li class="reservation-list-item col-12 d-flex justify-content-start">
    <div class="input-table-shadow" @click="selectItem">
      <div class="d-flex row align-items-center">
        <div class="col-1 reservation-id-col">
          <input
            class="pl-3 reservation-id"
            type="text"
            :value="item.id"
            readonly="readonly"
          />
          <span  v-tooltip.right-start="showStatus(item)" v-if="item.autoBooking === '1' || item.autoBooking === 1" class="auto-flag">A</span>
          <router-link :to="'/reservation/' + this.item.id" target="_blank">
            <img src="@/assets/svg/external-link.svg" alt="" />
          </router-link>
        </div>
        <div class="col col-60px">
          <input
            type="text"
            :value="getTime(item.created)"
            readonly="readonly"
          />
        </div>
        <div :title="translateField(item.paymentStatus, 'name')" class="col-2 price-col" :class="{ 'color-green': item.paymentStatus && item.paymentStatus.code === 'PAID', 'color-blue': (item.paymentStatus && item.paymentStatus.code === 'UNPAID'), 'color-orange':item.paymentStatus && (item.paymentStatus.code === 'TWENTY_PERCENT_PAID' || item.paymentStatus.code === 'PARTIALLY_PAID') }">
          {{formatMoney(item.totalPaidPrice)}} / {{ parseInt(item.totalCustomPrice) ? formatMoney(item.totalCustomPrice) : formatMoney(item.totalSalePrice) }}
        </div>
        <div class="col col-30px">
          <input
            type="text"
            :value="getUserInitials(item.user)"
            readonly="readonly"
          />
        </div>
        <div class="col-1 input-group border-right">
          <input
            type="text"
            class="form-control"
            style="width: auto;"
            :value="item.paymentMethod"
            readonly="readonly"
          />
          <div class="input-group-append">
            <span class="paid">{{ item.paid }}</span>
          </div>
        </div>
        <div class="col-1 dark-background">
          <input
            type="text"
            :value="$moment(item.dateFrom, 'YYYY-MM-DD').format('DD.MM.YYYY')"
            readonly="readonly"
          />
        </div>
        <div class="col-2 dark-background">
          <input
            type="text"
            :value="translateField(item.service, 'title')"
            readonly="readonly"
          />
        </div>
        <div class="col-2 dark-background" :class="{ 'color-green': item.reservationStatus.code === 'DONE', 'color-blue': item.reservationStatus.code === 'TODO', 'color-orange': item.reservationStatus.code === 'PENDING', 'color-red': item.reservationStatus.code === 'CANCELLED' }">
          {{ translateField(item.reservationStatus, 'name') }}
        </div>
        <div class="col-2 dark-background mr-3">
          <input type="text" :value="personName" readonly="readonly" />
        </div>
        <!-- <div class="col-1 dark-background">
                    <input type="text" :class="actionColor" :value="item.reservationStatus.code" readonly="readonly" />
                </div> -->
      </div>
    </div>
    <div class="pl-2 d-flex align-items-center">
      <core-icon
        @click.native="deleteItem()"
        class="pointer"
        iconName="Delete"
        iconColor="#bdbdbd"
      >
        <icons-close></icons-close>
      </core-icon>
    </div>
  </li>
</template>

<script>
import Reservation from '@/services/hatsApi/Reservation'
import { moneyFormat } from '@/mixins/moneyFormat'
import moment from 'moment'

export default {
  mixins: [moneyFormat],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    statusColorClass () {
      let className = ''
      if (this.item.reservationStatus.code) {
        let statCode = this.item.reservationStatus.code
        if (statCode === 'DONE') {
          className = 'green'
        } else if (statCode === 'TODO') {
          className = 'blue'
        } else if (statCode === 'PENDING') {
          className = 'orange'
        } else if (statCode === 'CANCELLED') {
          className = 'red'
        }
        return 'input-' + className
      }
    },
    personName () {
      return this.item.person.firstName + ' ' + this.item.person.lastName
    },
    actionColor () {
      return `status-${this.item.reservationStatus.code.toLowerCase()}`
    }
  },
  methods: {
    showStatus (item) {
      if (!item.autoBooking || !item.autoBookingStatus) {
        return ''
      }
      let minStart = moment().add(14, 'days').format('YYYYMMDD')
      let dateFrom = moment(item.dateFrom).format('YYYYMMDD')
      if (item.autoBookingStatus === 'WAITING' && (item.service.cantBeAutoBooked || dateFrom < minStart)) {
        return ''
      }
      return item.autoBookingStatus
    },
    getTime (date) {
      if (!date) {
        return ''
      }
      return this.$moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')
    },
    translateField (item, field) {
      return item ? item[field + '_' + this.$i18n.locale.toUpperCase()] : ''
    },
    getUserInitials (user) {
      if (!user) {
        return ''
      }
      if (user.firstName && user.lastName) {
        let initials = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
        return initials.toUpperCase()
      }
      return ''
    },
    selectItem (e) {
      // if we click on link with target="_blank" we don't need to go inside twice
      if (e.target && e.target.getAttribute('target') !== '_blank' && e.target.parentElement.getAttribute('target') !== '_blank') {
        this.$router.push('/reservation/' + this.item.id)
      }
    },
    async deleteItem () {
      if (
        confirm(
          'Do you really want to delete reservation: ' + this.item.id + '?'
        )
      ) {
        try {
          let deleteResponse = await Reservation.deleteReservation(this.item.id)
          if (deleteResponse.data.success) {
            console.log('deleted')
          }
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
}
</script>

<style>
  .reservation-list-item .col, .reservation-list-item .col-1, .reservation-list-item .col-2 {
    padding: 0 4px
  }
  .reservation-id-col{
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
  }
  .reservation-id-col input[type="text"]{
    min-width: 50px;
  }
  .reservation-id {
    margin-right: 10px
  }
  .col.col-30px{
    max-width: 30px;
  }
  .col-60px{
    max-width: 60px;
  }
  .col.col-30px input[type="text"] {
    width: 20px;
    max-width: 20px;
  }

  .input-table .color-green, .color-green input.money-bold {
    color: #12b47d !important;
  }

  .input-table .color-red, .color-red input.money-bold {
    color: #A50000 !important;
  }

  .input-table .color-orange, .color-orange input.money-bold {
    color: #F59B00 !important;
  }

  .input-table .color-blue, .color-blue input.money-bold {
    color: #008CDD !important;
  }

  .price-col {
    font-size: 14px;
  }

  .auto-flag {
    padding:3px 5px;
    position: relative;
    left: -9px;
  }

  .non-auto {
    position: relative;
    right: -8px;
  }

  .external-link {
    position: relative;
    left: -20px;
    top: -5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reservation/ListItem.vue